import { Hero } from "./Hero";
import { Services } from "./Services";
import { Steps } from "./Steps";
import { Why } from "./Why";
import { Help } from "./Help";
import { Faq } from "./Faq";

export const Home = () => (
  <>
    <Hero />
    <Services />
    <Steps />
    <Why />
    <Help />
    <Faq />
  </>
);
